import { FilterTypes } from "../../../../types";
/**
 * Converts a `OptimizationTemplateFiltersMap` into a `Filter<OptimizationTemplateFilters>` object.
 *
 * This function processes the provided filters map and generates an array of filter fields
 * based on specific keys. It supports equality (`EQ`) filtering for fields like `search`,
 * `mediaType`, `status`, and `archivedStatus`, and inclusion (`IN`) filtering for the `id` field.
 *
 * @param filters - A map of filters (`OptimizationTemplateFiltersMap`) where the keys are
 *                  filter field names and the values are arrays of filter values.
 *                  Defaults to an empty `Map` if not provided.
 * @returns A `Filter<OptimizationTemplateFilters>` object containing a `where` clause
 *          with the generated filter fields. If the provided `filters` map is invalid
 *          or does not contain any valid filter fields, the `where` clause will be empty.
 */
export const toFilterGroupObjects = (filters = new Map()) => {
    if (typeof filters?.get !== "function") {
        return { where: [] };
    }
    const fields = [];
    ["search", "mediaType", "status", "archivedStatus"].forEach((field) => {
        const value = filters.get(field);
        if (value?.length) {
            fields.push({
                field,
                type: FilterTypes.EQ,
                value: value[0]
            });
        }
    });
    ["id"].forEach((field) => {
        const value = filters.get(field);
        if (value?.length) {
            fields.push({
                field,
                type: FilterTypes.IN,
                value
            });
        }
    });
    return { where: fields };
};
//# sourceMappingURL=objects.js.map